export const locales = {
	skipLink: 'Contenu principal'
};
